"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var connect_1 = require("@0x/connect");
var order_utils_1 = require("@0x/order-utils");
var utils_1 = require("@0x/utils");
var _ = require("lodash");
var types_1 = require("../types");
var assert_1 = require("../utils/assert");
var StandardRelayerAPIOrderProvider = /** @class */ (function () {
    /**
     * Instantiates a new StandardRelayerAPIOrderProvider instance
     * @param   apiUrl      The standard relayer API base HTTP url you would like to source orders from.
     * @return  An instance of StandardRelayerAPIOrderProvider
     */
    function StandardRelayerAPIOrderProvider(apiUrl) {
        assert_1.assert.isWebUri('apiUrl', apiUrl);
        this.apiUrl = apiUrl;
        this._sraClient = new connect_1.HttpClient(apiUrl);
    }
    /**
     * Given an array of APIOrder objects from a standard relayer api, return an array
     * of SignedOrderWithRemainingFillableMakerAssetAmounts
     */
    StandardRelayerAPIOrderProvider._getSignedOrderWithRemainingFillableMakerAssetAmountFromApi = function (apiOrders) {
        var result = _.map(apiOrders, function (apiOrder) {
            var order = apiOrder.order, metaData = apiOrder.metaData;
            // The contents of metaData is not explicity defined in the spec
            // We check for remainingTakerAssetAmount as a string and use this value if populated
            var metaDataRemainingTakerAssetAmount = _.get(metaData, 'remainingTakerAssetAmount');
            var remainingFillableTakerAssetAmount = metaDataRemainingTakerAssetAmount
                ? new utils_1.BigNumber(metaDataRemainingTakerAssetAmount)
                : order.takerAssetAmount;
            var remainingFillableMakerAssetAmount = order_utils_1.orderCalculationUtils.getMakerFillAmount(order, remainingFillableTakerAssetAmount);
            var newOrder = __assign({}, order, { remainingFillableMakerAssetAmount: remainingFillableMakerAssetAmount });
            return newOrder;
        });
        return result;
    };
    /**
     * Given an object that conforms to OrderProviderRequest, return the corresponding OrderProviderResponse that satisfies the request.
     * @param   orderProviderRequest   An instance of OrderProviderRequest. See type for more information.
     * @return  An instance of OrderProviderResponse. See type for more information.
     */
    StandardRelayerAPIOrderProvider.prototype.getOrdersAsync = function (orderProviderRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var makerAssetData, takerAssetData, orderbookRequest, orderbook, err_1, apiOrders, orders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert_1.assert.isValidOrderProviderRequest('orderProviderRequest', orderProviderRequest);
                        makerAssetData = orderProviderRequest.makerAssetData, takerAssetData = orderProviderRequest.takerAssetData;
                        orderbookRequest = { baseAssetData: makerAssetData, quoteAssetData: takerAssetData };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._sraClient.getOrderbookAsync(orderbookRequest)];
                    case 2:
                        orderbook = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error(types_1.AssetBuyerError.StandardRelayerApiError);
                    case 4:
                        apiOrders = orderbook.asks.records;
                        orders = StandardRelayerAPIOrderProvider._getSignedOrderWithRemainingFillableMakerAssetAmountFromApi(apiOrders);
                        return [2 /*return*/, {
                                orders: orders,
                            }];
                }
            });
        });
    };
    /**
     * Given a taker asset data string, return all availabled paired maker asset data strings.
     * @param   takerAssetData   A string representing the taker asset data.
     * @return  An array of asset data strings that can be purchased using takerAssetData.
     */
    StandardRelayerAPIOrderProvider.prototype.getAvailableMakerAssetDatasAsync = function (takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var maxPerPage, requestOpts, assetPairsRequest, fullRequest, response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maxPerPage = 1000;
                        requestOpts = { perPage: maxPerPage };
                        assetPairsRequest = { assetDataA: takerAssetData };
                        fullRequest = __assign({}, requestOpts, assetPairsRequest);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._sraClient.getAssetPairsAsync(fullRequest)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        throw new Error(types_1.AssetBuyerError.StandardRelayerApiError);
                    case 4: return [2 /*return*/, _.map(response.records, function (item) {
                            if (item.assetDataA.assetData === takerAssetData) {
                                return item.assetDataB.assetData;
                            }
                            else {
                                return item.assetDataA.assetData;
                            }
                        })];
                }
            });
        });
    };
    return StandardRelayerAPIOrderProvider;
}());
exports.StandardRelayerAPIOrderProvider = StandardRelayerAPIOrderProvider;
//# sourceMappingURL=standard_relayer_api_order_provider.js.map